import { call } from 'redux-saga/effects';
import { signalingPollDeleted } from 'features/polls/actions';
import { closeSharedPollNotificationSaga } from 'features/polls/sagas/closeSharedPollNotificationSaga';

export function* onPollDeletedSaga(action: ReturnType<typeof signalingPollDeleted>) {
  yield call(closeSharedPollNotificationSaga, action.payload.id);
}
